import { Error, HTMLElement, parentElement } from "@acng/frontend-bounty";
import { REGISTRY_ELEMENT } from "../model/resource.js";
import { TemplateUtility } from "./utility/template.js";
const CONNECTED = Symbol();
const PARENT = Symbol();
const TEMPLATE = Symbol();
const TAGNAME = Symbol();
/**
 * @typedef Controller
 * @property {() => void} [mount]
 * @property {() => void} [unmount]
 * @property {(template: TemplateUtility) => void} render
 */
/**
 * @implements {Controller}
 */
export class Widget extends HTMLElement {
    /**
     * @type {Array<import('@acng/frontend-relativity').Context<any>>}
     */
    static consumables = [];
    /**
     * @type {HTMLTemplateElement | undefined}
     */
    static [REGISTRY_ELEMENT];
    /**
     * @type {boolean | string[] | string}
     */
    static template = true;
    /**
     * @type {string | undefined}
     */
    static [TAGNAME];
    /**
     * @param {string} tagname
     */
    static async load(tagname) {
        DEBUG: if (this[TAGNAME]) {
            throw Error();
        }
        this[TAGNAME] = tagname;
    }
    static async setup() { }
    connectedCallback() {
        /** @internal */
        this[PARENT] = parentElement(this);
        if (this[CONNECTED]) {
            this.mount();
            return;
        }
        /** @internal */
        this[CONNECTED] = true;
        const CustomWidget = /** @type {typeof Widget} */ (this.constructor);
        if (CustomWidget[REGISTRY_ELEMENT]) {
            /**
             * @type {TemplateUtility}
             */
            const template = new TemplateUtility(CustomWidget[REGISTRY_ELEMENT]);
            /** @internal */
            this[TEMPLATE] = template;
            template.apply(this);
        }
        this.mount();
    }
    disconnectedCallback() {
        this[PARENT] = null;
        this.unmount();
    }
    get parent() {
        if (!this[PARENT]) {
            throw Error();
        }
        return this[PARENT];
    }
    get template() {
        const template = this[TEMPLATE];
        if (!template) {
            throw Error();
        }
        return template;
    }
    /**
     * @deprecated
     */
    get elements() {
        const template = this.template;
        const elements = Object.create(template.elements);
        Object.assign(elements, template.textNodes);
        return elements;
    }
    /**
     * @param {TemplateUtility} template
     */
    render(template) { }
    mount() { }
    unmount() { }
}
